import React from 'react';
import { getEntityUrl } from '@culture/common-helpers/cultureUtils';
import { statusesHash } from '@culture/utils/helpers/statuses';

import Tag from 'components/Tag';
import Container from 'components/Container';
import StyledContent from 'components/StyledContent';
import GroupElements from 'components/GroupElements';

import EntitiesPropTypes from 'utils/propTypes/entities';

import styles from './styles.module.scss';

const BroadcastInformation = ({ broadcast }) => {
	const { organizationName, jsonText, tags, institute } = broadcast;

	const broadcastOrganizationName =
		organizationName || institute?.passport?.organization || institute?.title;

	const publishedTags = tags?.filter(
		({ status }) => status === statusesHash.published
	);

	return (
		<Container width="narrow">
			<div className={styles.content}>
				<StyledContent blocks={jsonText} tagsTheme="light" />
			</div>
			{!!publishedTags?.length && (
				<GroupElements className={styles.tags}>
					{publishedTags.map((tag) => (
						<Tag
							key={tag.name}
							title={tag.title}
							url={getEntityUrl('tags', tag)}
						/>
					))}
				</GroupElements>
			)}
			<div className={styles.line} />
			<div className={styles.disclaimer}>
				<p>
					{broadcastOrganizationName && (
						<>
							Информация предоставлена организацией {broadcastOrganizationName}.{' '}
						</>
					)}
					Администрация портала &laquo;
					<a href="/">Культура.РФ</a>&raquo; не несет ответственности за
					достоверность представленных сведений, а также за действия
					Организатора и/или иных лиц, действующих от его имени и по его
					поручению либо от своего имени, но по поручению Организатора, а равно
					за организацию, проведение и содержание онлайн трансляции.
				</p>
				<p>
					Администрация портала оставляет за собой право без предупреждения
					отменить трансляцию, не соответствующую критериям качества. С полным
					перечнем критериев можно ознакомиться{' '}
					<a href="/s/stream-quality.pdf">здесь</a>.
				</p>
			</div>
		</Container>
	);
};

BroadcastInformation.propTypes = {
	broadcast: EntitiesPropTypes.broadcastItem.isRequired
};

export default BroadcastInformation;
